import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'

const ImageLink = styled(Link)`
  cursor: pointer;
`

const Image = styled.img`
  width: ${props => (props.width ? props.width : '26px')};
  height: ${props => (props.height ? props.height : '21px')};
  object-fit: contain;
  margin: auto;
  vertical-align: middle;
  display: inline-block;
`
function Logo({ to, icon, width, height }) {
  return (
    <ImageLink to={to}>
      <Image src={icon} alt="PPM" width={width} height={height} />
    </ImageLink>
  )
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/icon2/icon.js